import { MutationCache, QueryClient } from '@tanstack/react-query';

import { reportTransportFailure } from '@/lib/utils/sentry';

/**
 * App-wide TanStack Query client, exported as a singleton so it can be read
 * imperatively outside of React (e.g. `isFeatureEnabled`) via
 * `queryClient.getQueryData(...)`, not only through the `QueryClientProvider`.
 */
export const queryClient = new QueryClient({
  // DC-3628: a mutation whose request never comes back reaches no one — the
  // hey-api error interceptor only fires when there *is* a response. Reporting
  // it here covers every mutation instead of one `onError` at a time. The
  // payload is opt-in (`meta: { reportPayload: true }`) because this also sees
  // the auth mutations, whose variables are credentials.
  mutationCache: new MutationCache({
    onError: (error, variables, _context, mutation) =>
      reportTransportFailure(error, variables, {
        reportPayload: mutation.meta?.reportPayload === true,
        endpoint:
          typeof mutation.meta?.endpoint === 'string'
            ? mutation.meta.endpoint
            : undefined,
        elapsedMs: Date.now() - mutation.state.submittedAt,
      }),
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: 1000 * 10,
      retry: 2,
    },
  },
});
